import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-exercise-conclude',
    templateUrl: './exercise-conclude.component.html',
    styleUrls: ['./exercise-conclude.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class ExerciseConcludeComponent implements OnInit {

  hintCollapsed = true;

  constructor() { }

  ngOnInit() {
  }

}
